import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
} from "@mui/material";
import { MouseEvent } from "react";

interface IOwnProps {
    open: boolean;
    onClose: (e: MouseEvent<HTMLButtonElement>) => void;
}
const SnapshotAccessDialog = ({ open, onClose }: IOwnProps) => (
    <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
    >
        <DialogContent>
            <DialogContentText id="alert-dialog-description">
                Interested in our Historical Snapshots?{" "}
                <a
                    href="https://retailstat.com/product-location-poi"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Click here
                </a>{" "}
                &nbsp;to find out more.
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button onClick={onClose} color="primary">
                Close
            </Button>
        </DialogActions>
    </Dialog>
);

export default SnapshotAccessDialog;
